import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

export interface ILedgerAdjustmentPayload {
    fromLedgerId: string;
    toLedgerId: string;
    amount: number;
    reason: string;
    entryDate?: string;
}

export interface ILedgerAdjustmentResponse {
    success: boolean;
    message: string;
    data: {
        fromLedgerId: string;
        toLedgerId: string;
        amount: number;
        journalEntryId: string;
        voucherNumber: string;
        financialYear: string;
    };
}

/**
 * Record a manual ledger adjustment (Journal Entry)
 */
export const recordLedgerAdjustment = createAsyncThunk(
    'ledgerAdjustment/recordLedgerAdjustment',
    async (payload: ILedgerAdjustmentPayload, { rejectWithValue }) => {
        try {
            const response = await axios.post<ILedgerAdjustmentResponse>('/api/v1/coa/ledgers/entry', payload);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data?.message || 'Failed to record adjustment');
        }
    }
);
